import { Role } from '../model/entities';
import providerAuthService from '../services/ProviderAuthService';
import { proxyApiAxios } from './CustomAxios';

class RoleApi {
    list = async (hubId: string, projectId: string): Promise<Role[]> => {
        const headers = await providerAuthService.getRequestHeader('ACC');
        const response = await proxyApiAxios.get<Role[]>('/industry-roles', {
            params: {
                hubId,
                projectId,
            },
            headers,
        });
        return response.data;
    };
}

const roleApi: RoleApi = new RoleApi();
export default roleApi;
